package com.bulut.mecitogullari.di

import com.bulut.mecitogullari.core.firebase.FirebaseConfig
import com.bulut.mecitogullari.core.firebase.initFirebase
import com.bulut.mecitogullari.core.i18n.Localization
import com.bulut.mecitogullari.core.session.SessionManager
import com.bulut.mecitogullari.core.storage.AppStorage
import com.bulut.mecitogullari.core.tenant.CompanyProfile
import com.bulut.mecitogullari.data.repository.ProfileRepository
import com.mmk.kmpauth.google.GoogleAuthCredentials
import com.mmk.kmpauth.google.GoogleAuthProvider
import org.koin.core.context.startKoin
import org.koin.core.context.stopKoin
import org.koin.dsl.KoinAppDeclaration
import org.koin.mp.KoinPlatformTools

/**
 * Bootstraps Firebase, Google Sign-In and Koin, then restores any persisted
 * session. Safe to call more than once (subsequent calls are no-ops).
 *
 * Called from each platform entry point:
 * Android Application (passing the application context), iOS
 * MainViewController, web main().
 */
fun initKoin(platformContext: Any? = null, config: KoinAppDeclaration? = null) {
    if (KoinPlatformTools.defaultContext().getOrNull() != null) return

    initFirebase(platformContext)
    GoogleAuthProvider.create(
        credentials = GoogleAuthCredentials(serverId = FirebaseConfig.WEB_CLIENT_ID),
    )

    val koinApp = startKoin {
        config?.invoke(this)
        modules(appModules)
    }
    Localization.init(koinApp.koin.get<AppStorage>())
    SessionManager.start()
    CompanyProfile.start(koinApp.koin.get<ProfileRepository>())
}

fun shutdownKoin() = stopKoin()
